import { useI18n } from 'builder/hooks/useI18n'
import { SpinnerLight } from 'builder/components/Spinner'
import { LoadingStatus } from '../../components/LoadingStatus/LoadingStatus'
import { Caption, JobPostingContainer, Title } from '../../styles'
import { JobPostingProps } from '../../types'
import { Container, Content } from './styles'

const translationKey = 'builder.resume_optimizer.job_posting'

export const LinkProcessingStep = (props: JobPostingProps) => {
  const { children } = props
  const { i18n } = useI18n()

  return (
    <>
      <JobPostingContainer>
        <Container>
          <LoadingStatus
            title={i18n.t(`${translationKey}.calculating_score`)}
            icon={<SpinnerLight $width="24px" $height="24px" />}
          />
          <Content>
            <Title>{i18n.t(`${translationKey}.loading.title`)}</Title>
            <Caption>{i18n.t(`${translationKey}.loading.content`)}</Caption>
          </Content>
        </Container>
      </JobPostingContainer>
      {children}
    </>
  )
}
